import type { Feature } from '../types';

/**
 * Converts a feature record into a flat Feature array.
 * Encapsulates the Object.values conversion so domain modules and
 * aggregation files never call Object.values directly.
 */
export function featureList(features: Record<string, Feature>): Feature[] {
  return Object.values(features);
}
